/** @jsx jsx */
import { css, jsx } from '@emotion/core'

import ContentField from './ContentField'
import SurveyLabels from './SurveyLabels'
import { Heading } from './'

const containerCss = css`
  height: 100%;
  margin-top: 10px;
  overflow: scroll;
  cursor: default;

  .lc-btn {
    padding: 6px 12px;

    > div {
      display: flex;
      align-items: center;
    }
  }
`

const boxCss = css`
  border-radius: 4px;
  background-color: white;
  padding: 15px;
  box-shadow: rgb(228 228 228) 0px 1px 5px 0px;
  margin-bottom: 10px;
  min-height: 85px;
`

const sectionCss = css`
  margin-bottom: 30px;
`

const SurveySettings = ({ survey }) => {
  return (
    <div css={containerCss}>
      <div css={boxCss}>
        <div css={sectionCss}>
          <Heading
            label="Survey Labels"
            info="Add label to your survey to make it easier to find."
          />
          <SurveyLabels survey={survey} />
        </div>
      </div>
      <div css={boxCss}>
        <div css={sectionCss}>
          <Heading
            label="Survey Card"
            info="Customize the survey card that visitor will receive while chatting."
          />
          <ContentField
            survey={survey}
            contentName="card_description"
            className="box"
            placeholder="Contains 3 questions"
            label="Card description"
          />
          <ContentField
            survey={survey}
            className="box"
            contentName="open_survey_button"
            placeholder="Fill the survey"
            label="Button that opens the survey"
          />
        </div>
        <div css={sectionCss}>
          <Heading
            label="Survey Content"
            info="Customize the view a visitor will see when completing a survey."
          />
          <ContentField
            survey={survey}
            contentName="send_response_button"
            className="box"
            placeholder="Send response"
            label="Button that submits the survey"
          />
        </div>
        <div css={sectionCss}>
          <Heading
            label="Thank You Page"
            info="Customize the view that visitor will see right after completing the survey."
          />
          <ContentField
            survey={survey}
            className="box"
            contentName="confirmation_title"
            placeholder="Thank you for your feedback."
            label="Confirmation title"
          />
          <ContentField
            survey={survey}
            className="box"
            contentName="confirmation_description"
            placeholder="We appreciate you sharing your thoughts."
            label="Confirmation description"
          />
          <ContentField
            survey={survey}
            className="box"
            contentName="confirmation_message"
            placeholder="The survey has been completed!"
            label="Confirmation message"
          />
        </div>
      </div>
    </div>
  )
}

export default SurveySettings
